<div [style.display]="'none'">
	<ng-container *ngFor="let font of customFonts"> 
		{{ font.originalfilename | fonts: font: assetBaseUrl }}
	</ng-container>
</div>

<form #formRef="ngForm">
	<div class="body-column tab-container">
		<interactivity-editor *ngIf="entity && ( activeId === entity.id || isNew )"></interactivity-editor>
	</div>
</form>
<bb-versions
	*ngIf="showVersions"
	theme="dark"
	(clickOutside)="showVersions = false"
	[clickOutsideExclude]="historyButton"
	(versionSelected)="loadVersion($event)"
	(versionStateSelected)="setVersionState($event)" 
	[entityDetails]="entityDetails"
	[entityConfiguration]="entityConfiguration"
></bb-versions>
<bb-actions-bar
	(onUndo)="undo()"
	(onRedo)="redo()"
	(onSave)="save()"
	(onPublish)="onPublishClick()"
	(onCancel)="cancel()"
	(onDelete)="delete()"
	(onPreview)="onPreview()"
	[saveDisabled]="interactivityEditorService?.justConverted"
	[hideDelete]="true"
	[trackPreviewWindow]="true"
	[previewLink]="'#/preview?type=' + 
		(entity?.parentEntityType === 'Project' ? 'p' : 'c') + '&' +
		(entity?.parentEntityType === 'Project' ? 'projectId=' : 'clipId=') + (entity?.parentEntityType === 'App' ? 'ovp2575390' : entity?.parentEntityId ) +
		'&interactivityId=' + entity?.id + 
		(entity?.parentEntityType === 'App' ? '&templateId=' + entity?.parentEntityId : '')"
	[form]="form"
	[entityConfiguration]="entityConfiguration"
	[entity]="entity"
>
	<div class="action-button position-start" (click)="showVersions = !showVersions" #historyButton>
		{{ 'HISTORY' | translate }} justConverted = {{interactivityEditorService?.justConverted}}
		<i class="fa fa-angle-up" *ngIf="!showVersions"></i>
		<i class="fa fa-angle-down" *ngIf="showVersions"></i>
	</div>
</bb-actions-bar>

<ng-template #publishDraftItemsTemplate>
	<bb-mediaclips-publisher
		[toPublishMediaClips]="toPublishMediaClips"
		(allClipsPublished)="publish()"
		(continue)="continuePublish()"
		(cancel)="cancelPublish()"
		(error)="cancelPublish()">
	</bb-mediaclips-publisher>
</ng-template>
